import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4087b5d4 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _4bdca9a2 = () => interopDefault(import('../pages/catchment.vue' /* webpackChunkName: "pages/catchment" */))
const _50429b16 = () => interopDefault(import('../pages/demographics.vue' /* webpackChunkName: "pages/demographics" */))
const _58d0d2fe = () => interopDefault(import('../pages/school/index.vue' /* webpackChunkName: "pages/school/index" */))
const _366cea86 = () => interopDefault(import('../pages/trends.vue' /* webpackChunkName: "pages/trends" */))
const _9e73ec1e = () => interopDefault(import('../pages/zdemographics.vue' /* webpackChunkName: "pages/zdemographics" */))
const _571a31b6 = () => interopDefault(import('../pages/school/_slug.vue' /* webpackChunkName: "pages/school/_slug" */))
const _0118004a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: decodeURI('/extensions/enrollment-public/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _4087b5d4,
    name: "about"
  }, {
    path: "/catchment",
    component: _4bdca9a2,
    name: "catchment"
  }, {
    path: "/demographics",
    component: _50429b16,
    name: "demographics"
  }, {
    path: "/school",
    component: _58d0d2fe,
    name: "school"
  }, {
    path: "/trends",
    component: _366cea86,
    name: "trends"
  }, {
    path: "/zdemographics",
    component: _9e73ec1e,
    name: "zdemographics"
  }, {
    path: "/school/:slug",
    component: _571a31b6,
    name: "school/slug"
  }, {
    path: "/",
    component: _0118004a,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
